import DataMiddleware from '@/components/_core/GridsCore/helpers/DataMiddleware'
import GridHelpers from '@/components/_core/GridsCore/helpers/GridHelpers'
import ColumnHelpers from '@/components/_core/GridsCore/helpers/ColumnHelpers'
import router from '@/router'
import Debug from 'logdown'
import cloneDeep from 'lodash/cloneDeep'
import librariesStore from '@/store/modules/models/libraries'
import _orderBy from 'lodash.orderby'
const d = new Debug('its:molecules:description')
// import cloneDeep from 'lodash/cloneDeep'
let Libraries = {
  totalCount: 0,
  params: null,
  fetcher: function () {
    return {
      getRows (params) {
        // deselect all - paging breaks if cells are selected or open
        GridHelpers.deselectAll()

        Libraries.params = params
        Libraries.serverLookupReadyCheck()
      } // getRows
    } // return
  }, // fetcher

  /// / first lopp through a readiness detector, since sometimes the site isn't loaded enough to check
  serverLookupReadyCheck () {
    if (router.currentRoute.value.meta.manageType) {
      GridHelpers.mgThisArray[0].showMasterGridTogger = Math.random()
      if (Libraries) {
        Libraries.serverLookup()
      }
    } else {
      d.log('ServerSideDatasourceLibraries serverLookupReadyCheck')
    }
  },

  serverLookup () {
    let perPage = GridHelpers.mgThisArray[0].cacheBlockSize
    let params = Libraries.params

    // get sort state, then add random at end
    let sortState = cloneDeep(GridHelpers.mgThisArray[0].gridApi.getColumnState())
    let columnsSorted = []
    if (sortState) {
      columnsSorted = sortState.filter(x => x['sort'] !== null)
    }
    let sortObj = {}
    if (columnsSorted.length > 0) {
      columnsSorted = _orderBy(columnsSorted, ['sortIndex'], ['asc'])
      for (let i = 0; i < columnsSorted.length; i++) {
        let obj = columnsSorted[i]
        let dir = (obj.sort === 'asc') ? 1 : -1

        // replace primary file with files.
        let colId = obj.colId
        if (colId.indexOf('primaryFile') > -1) {
          colId = colId.replace('primaryFile.', 'files.')
        }

        sortObj[colId] = dir
      }
    } else {
      sortObj = {
        name: 1
      }
    }

    // return total count - always do it because the count can change if we delete rows or move their status
    // let doTotalCount = (params.request.startRow === 0 || ServerSideDatasourceLibraries.totalCount === 0)
    let doTotalCount = true

    // MAIN FETCH
    let payload = {}
    payload._select = {
      nameTokens: 0,
      'files.filenameTokens': 0,
      'files.content': 0
    }

    payload.libraryType = GridHelpers.mgThisArray[0].$route.meta.manageType
    payload._manage = true
    payload._options = {
      totalCount: doTotalCount, // if you set this, it makes response zero
      limit: perPage,
      skip: params.request.startRow,
      sort: sortObj,
      agGrid: {
        endRow: params.request.endRow,
        startRow: params.request.startRow
      }
    }

    // MERGE ROUTE PARAMS INTO OUR MODEL
    payload = Object.assign(payload, librariesStore.state.repositoryQueryParams)

    // ADD FILTERS
    let filters = ColumnHelpers.getAllFilters()
    for (let property in filters.activeFilters) {
      // tweak property for back end
      let propertyBackend = property
      if (property.indexOf('primaryFile') > -1) {
        propertyBackend = property.replace('primaryFile.', 'files.')
      }
      // set property value
      if (filters.activeFilters.hasOwnProperty(property)) {
        let values = ''
        if (Array.isArray(filters.activeFilters[property])) {
          values = Object.values(filters.activeFilters[property])
          let index = values.indexOf('')
          if (index !== -1) {
            values[index] = 'null'
          }
        } else {
          values = filters.activeFilters[property]
        }
        payload[propertyBackend] = values
      }
    }

    // clean up bad stuff
    delete payload._uiOptions

    // start lookup
    GridHelpers.mgThisArray[0].$store.dispatch('VUEX_LIBRARIES_GRID_ROWDATA_LOADING_START')
    GridHelpers.mgThisArray[0].$store.dispatch('VUEX_LIBRARIES_PAGED_DATA_FETCH', payload).then(response => {
      if (params.parentNode?.beans?.context?.destroyed) {
        // check for destroyed -this issue has promising notes
        // https://github.com/ag-grid/ag-grid/issues/3334#issuecomment-584403287
      } else {
        // NOT DESTROYED
        if (response) {
          let resp = response.data[0] || response.data

          // set total count
          // if total count is there, grab it once
          // otherwise, the data is no longer nested, so change resp to be response
          if (resp.totalCount) {
            Libraries.totalCount = resp.totalCount
          } else {
            // resp = response
            Libraries.totalCount = 0
          }

          // set rows
          let rows = resp.data
          rows = DataMiddleware.convertLibrariesToRowData(rows)
          if (rows.length > 0) {
            // did we hit the last row?
            let endRow = payload._options.agGrid.endRow
            let startRow = payload._options.agGrid.startRow

            let lastRow = -1
            if (endRow < Libraries.totalCount) { // if more pages
              lastRow = Libraries.totalCount
            } else if (endRow >= Libraries.totalCount && startRow === 0) { // if first page is smaller that subsets
              lastRow = Libraries.totalCount
            }

            GridHelpers.mgThisArray[0].showMasterGridTogger = Math.random()
            params.success({
              rowData: rows,
              rowCount: lastRow
            })
          } else {
            Libraries.totalCount = 0
            GridHelpers.mgThisArray[0].showMasterGridTogger = Math.random()
            params.success({
              rowData: rows,
              rowCount: 0
            })
          }
        } else {
          Libraries.totalCount = 0
          GridHelpers.mgThisArray[0].showMasterGridTogger = Math.random()
          params.fail()
        }

        // end lookup
        GridHelpers.mgThisArray[0].$store.dispatch('VUEX_LIBRARIES_GRID_ROWDATA_LOADING_FINISH')
      }// DESTROYED
    }) // lookup
  } // gettrows2
}

export default Libraries
